import React from 'react';
import styled, { keyframes } from 'styled-components';

const Preloader = () => (
  <Root>
    <First />
    <Middle />
    <Last />
  </Root>
);

const firstCircle = keyframes`
  0% {
    background-color: rgba(0, 0, 0, 0.5);
  }
  50% {
    background-color: rgba(0, 0, 0, 0.7);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const middleCircle = keyframes`
  0% {
    background-color: rgba(0, 0, 0, 0.3);
  }
  50% {
    background-color: rgba(0, 0, 0, 0.5);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

const lastCircle = keyframes`
  0% {
    background-color: rgba(0, 0, 0, 0.7);
  }
  50% {
    background-color: rgba(0, 0, 0, 0.3);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

const Root = styled.div`
  display: inline-flex;
  align-items: center;
  min-height: 20px;
`;

const First = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
  border-radius: 100%;
  animation: ${firstCircle} 1.2s linear infinite;
`;

const Middle = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
  border-radius: 100%;
  animation: ${middleCircle} 1.2s linear infinite;
`;

const Last = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  animation: ${lastCircle} 1.2s linear infinite;
`;

export default Preloader;
